<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wCxCNb/tc-custom/FC-9781645750390.jpg?1684515577083?1719602262915" alt="This image is the cover for the book Empty Handed"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Empty Handed
      </h1>
      <p class="bookDescription body article font2">
        <p><em>Empty H</em><em>an</em><em>ded: A Modern-Day Miyagi</em> tells the story of author Nathan Chlumsky, who grew up in a small town of Kansas, bullied and abused, and told he would never make it in the martial arts. Now, almost 28 years later, he has black belt rankings in multiple disciplines and is about to test for his 5th degree black. He is also a 3x Martial Arts Hall of Fame Inductee and one of the top martial arts historians in the world. This book tells how he overcame all that was thrown at him to become the <em>Modern Day Miyagi </em>that he is today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sensei Nathan Chlumsky
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-size:13px;font-family:"Times New Roman",serif;'>Sensei Nathan Chlumsky</span> was contacted by Strathmore Worldwide in October 2019 after being nominated by someone and is now in Strathmore&rsquo;s <em>Who&rsquo;s Who Worldwide 2019 Edition</em> as being &lsquo;professional of the year in martial arts instruction and historical research.&rsquo; Strathmore lists the top professionals of any field, every year, of which the book is meant to be used as a source of contact and communication with other professionals of the same and/or similar field. Also, on October 23, 2020, author&rsquo;s picture congratulating the accomplishment with Strathmore was featured on the famous eight-story tall Thomas Reuter Billboard in Times Square, located in New York, for 24 hours.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78949f00